import { ref, watch } from '@vue/composition-api'

export default function useAutoSuggest(props) {
  const filteredData = ref({})

  /**
   * Filter group against provided query
   * Grp Structure:
   * {
   *    key: 'title',
   *    data: [
   *      title: 'Admin', img: 'someImage.png',
   *      title: 'Template', img: 'otherImage.png',
   *    ]
   * }
   * @param {Object} grp Group object to perform filter on
   * @param {String} query Query string to filter
   */

  const deepSearch = (data, key, query) => {
    return data.some(item => {
      if (Array.isArray(item[key])) {
        const subItemsMatched = deepSearch(item[key], key, query);
        if (subItemsMatched) {
          item[key] = item[key].map(subItem => ({ ...subItem, match: true }));
        }
        return subItemsMatched;
      }
      const match = item[key].toLowerCase().startsWith(query.toLowerCase());
      item.match = match;  // Set the "match" property for the current item
      return match;
    });
  };

  const filterGrp = (grp, query) => {
    const exactEle = grp.data.filter(item => {
      const titleMatches = item[grp.key].toLowerCase().startsWith(query.toLowerCase());
      const sectionMatches = deepSearch(item.sections, grp.key, query);
      return titleMatches || sectionMatches;
    });

    const containEle = grp.data.filter(item => {
      const titleMatches = item[grp.key].toLowerCase().indexOf(query.toLowerCase()) > -1;
      const sectionMatches = deepSearch(item.sections, grp.key, query);
      return !titleMatches && sectionMatches;
    });
    return exactEle.concat(containEle).slice(0, props.searchLimit);
  };


  const searchQuery = ref('')
  const resetsearchQuery = () => {
    searchQuery.value = ''
  }

  const handleSearchQueryUpdate = val => {
    if (val === '') {
      filteredData.value = {}
    } else {
      const queriedData = {}
      const dataGrps = Object.keys(props.data)


      dataGrps.forEach((grp, i) => {
        queriedData[dataGrps[i]] = filterGrp(props.data[grp], val)
      })

      // remove duplicate dataGrps.Pages by route name 
      queriedData.Pages = queriedData.Pages.reduce((acc, currentItem) => {
        const existingItem = acc.find(item => item.id_module === currentItem.id_module);
        if (!existingItem) {
          acc.push(currentItem);
        }
        return acc;
      }, []);

      filteredData.value = queriedData
    }
  }

  watch(searchQuery, val => handleSearchQueryUpdate(val))

  return {
    searchQuery,
    resetsearchQuery,
    filteredData,
  }
}
